export default function ComposeProviders({ components = [], children }) {
	return (
		<>
			{components.reduceRight((acc, Comp) => {
				return <Comp>{acc}</Comp>
			}, children)}
		</>
	)
}
